import { create } from 'zustand';
import type { FeaturedPreviewItem } from '../config/featuredTemplates';

/**
 * Bong 精选作品预览 store（点击展示卡 → 预览页）
 * - open(item)：WorksSection 点击链路调用，写入当前作品后 AppNew 切换到 featured 视图
 * - 不 persist：刷新时由 FeaturedPreviewPage 从 URL query（type/id）重建
 */
interface FeaturedPreviewState {
  current: FeaturedPreviewItem | null;
  open: (item: FeaturedPreviewItem) => void;
  close: () => void;
}

export const useFeaturedPreviewStore = create<FeaturedPreviewState>()((set) => ({
  current: null,
  open: (item) => set({ current: item }),
  close: () => set({ current: null }),
}));
